import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
}

const WhatsappIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>WhatsApp</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7891 23.391C27.3661 23.1793 25.2865 22.1561 24.8987 22.0148C24.511 21.8736 24.2291 21.8031 23.9471 22.2265C23.6651 22.6499 22.8544 23.6028 22.6076 23.885C22.3609 24.1673 22.1142 24.2028 21.6912 23.9909C21.2682 23.7793 19.9052 23.3326 18.2896 21.8914C17.0322 20.7698 16.1832 19.3846 15.9365 18.9612C15.6897 18.5377 15.9101 18.3088 16.1219 18.0979C16.3123 17.9084 16.5449 17.6038 16.7564 17.3568C16.968 17.1099 17.0384 16.9333 17.1794 16.6511C17.3204 16.3688 17.2499 16.1218 17.1441 15.9101C17.0384 15.6984 16.1925 13.6163 15.84 12.7692C15.4966 11.9445 15.1479 12.0562 14.8882 12.0432C14.6418 12.0309 14.3595 12.0283 14.0776 12.0283C13.7956 12.0283 13.3373 12.1342 12.9495 12.5575C12.5618 12.981 11.4691 14.0045 11.4691 16.0864C11.4691 18.1685 12.9848 20.1798 13.1963 20.4621C13.4078 20.7445 16.179 25.0169 20.4223 26.8492C21.4315 27.285 22.2194 27.5453 22.8337 27.7402C23.847 28.0622 24.7691 28.0168 25.498 27.9078C26.3107 27.7865 28.0006 26.8846 28.3531 25.8966C28.7055 24.9084 28.7055 24.0615 28.5998 23.885C28.4941 23.7086 28.2121 23.6028 27.7891 23.391ZM20.0711 33.9292H20.0654C17.5405 33.9282 15.0642 33.2499 12.9038 31.9679L12.39 31.6629L7.06459 33.0599L8.48602 27.8676L8.15153 27.3352C6.74299 25.095 5.99904 22.5058 6.00017 19.8471C6.00329 12.0892 12.3154 5.77759 20.0767 5.77759C23.835 5.77885 27.3678 7.24437 30.0244 9.90401C32.681 12.5636 34.1431 16.0988 34.1417 19.8584C34.1385 27.6169 27.8264 33.9292 20.0711 33.9292ZM32.0463 7.88307C28.8501 4.68321 24.5996 2.92019 20.0709 2.91833C10.7399 2.91833 3.14563 10.5122 3.14184 19.846C3.14065 22.8298 3.92013 25.742 5.40165 28.3094L3 37.0818L11.9742 34.7277C14.4469 36.0764 17.2309 36.7872 20.0642 36.7882H20.0712C29.4012 36.7882 36.9961 29.1936 37 19.8596C37.0017 15.3362 35.2424 11.0829 32.0463 7.88307Z"
        fill={fill}
      />
    </svg>
  );
};

export default WhatsappIcon;
